import * as React from 'react';
import { ProtectiveFunctionLocation } from '../models/protectiveFunctionLocation';
import { Message, MessageTemplateType } from "../models/ProtectiveFunctionWrapper";

interface Props {
    devicePosition: string;
    location: ProtectiveFunctionLocation;
    voting: string;
    diagramPosition: {
        top: string,
        left: string
    },
    size: {
        height: string,
        width: string
    };
    backgroundColor: string;
    onClick: (position: string, location: ProtectiveFunctionLocation, voting: string) => void;
    onRightClick: (e: React.MouseEvent, deviceLocation: string, configLocation: ProtectiveFunctionLocation) => void;
    configurationName: string;
    errorsAndWarnings: Message[];
}

const EmptyDevicePosition = (props: Props) => {
    var errorsAndWarnings: Message[] = [];
    var hasWarning: boolean = false;
    var hasError: boolean = false;
    var ErrorsAndWarningsText = "";

    if (props.errorsAndWarnings) {
        errorsAndWarnings = props.errorsAndWarnings.filter(x => x.messageItems ? x.messageTemplateType == MessageTemplateType.EnsureNoBlankChannels && x.messageItems.some(c => c.id == props.configurationName) : false);
        const filtered = errorsAndWarnings.find(x => x.messageItems.some(c => c.id == props.configurationName));
        if (filtered) {
            const messageItems = filtered.messageItems;
            const messageItem = messageItems.find(x => x.id == props.configurationName);
            const emptyColumns = messageItem.text.toString().split(',');
            const match = props.devicePosition.trim().match(/^D([1-9])([1-9])$/);
            if (match) {
                const columnIndex = match[1];
                if (emptyColumns.some(x => x == columnIndex)) {
                    hasWarning = errorsAndWarnings.some(x => x.messageType === 'warning');
                    hasError = errorsAndWarnings.some(x => x.messageType === 'error');
                    ErrorsAndWarningsText += errorsAndWarnings.map(x => x.formatMessageById(props.configurationName, true)).join('\n');
                }
            }
        }
    }

    return (
        <div
            id={props.devicePosition}
            style={{ zIndex: 10000, position: "absolute", top: props.diagramPosition.top, left: props.diagramPosition.left, height: props.size.height, width: props.size.width, backgroundColor: props.backgroundColor, pointerEvents: "all" }}
            onClick={() => props.onClick(props.devicePosition, props.location, props.voting)}
            onContextMenu={(e) => props.onRightClick(e, props.devicePosition, props.location)}
            className={`empty-input ${hasWarning ? "warning-message" : ""} ${hasError ? "error-message" : ""}`}
            title={ErrorsAndWarningsText}
        />
    );
}

export default EmptyDevicePosition;